// extracted by mini-css-extract-plugin
module.exports = {"favoritesList":"styles_favoritesList__eKgyE","empty":"styles_empty__3Z_XO","dropDown":"styles_dropDown__Ah5yK","show":"styles_show__3GBgZ"};